import React, { useEffect, useState } from 'react';

const MobileLoader = () => {

  const [finished, setFinishedLoading] = useState(false);

  useEffect(() => {
    const timer = () => setTimeout(() => setFinishedLoading(true), 2000);
    const timerId = timer();
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  return (
    <div className={`mobile-loader ${finished ? 'mobile-loader--finished' : null}`}>Search Results Updated</div>
  )
};

export default MobileLoader;